import { render, staticRenderFns } from "./towLevelView.vue?vue&type=template&id=50f96b42&scoped=true&"
import script from "./towLevelView.vue?vue&type=script&lang=js&"
export * from "./towLevelView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f96b42",
  null
  
)

export default component.exports